module.exports = __webpack_public_path__ + "img/preview.3efff928.jpg";